(() => {
  window.__BUNDLE_QTY__ = window.__BUNDLE_QTY__ || 1;
  window.__BUNDLE_CART_MAP__ = window.__BUNDLE_CART_MAP__ || {}; // variantId -> qty

  const money = (n) => (Math.round(n * 100) / 100).toFixed(2).replace(".", ",") + " €";
  const prog = (p) => (p <= 1 ? 0 : p === 2 ? 50 : 100);

  async function refreshCartMap() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();
      const map = {};
      (cart.items || []).forEach((it) => {
        map[String(it.id)] = (map[String(it.id)] || 0) + (it.quantity || 0);
      });
      window.__BUNDLE_CART_MAP__ = map;
    } catch (e) {}
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? String(idInput.value) : "";
  }

  function setQtyEverywhere(qty) {
    document.querySelectorAll('input[name="quantity"]').forEach((inp) => {
      inp.value = String(qty);
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
    document.querySelectorAll("quantity-input input").forEach((inp) => {
      inp.value = String(qty);
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // Initial cart state laden
  refreshCartMap();

  // Wichtig: VOR jedem /cart/add Submit die richtige Add-Menge setzen (Differenz!)
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes("/cart/add")) return;

      const desired = Number(window.__BUNDLE_QTY__ || 1);
      const variantId = getVariantIdFromForm(form);
      const already = Number(window.__BUNDLE_CART_MAP__[variantId] || 0);

      // Wir adden nur die Differenz, damit es NICHT über das Limit hinausgeht
      const delta = desired - already;

      // Wenn schon genug im Warenkorb liegt: nichts hinzufügen (verhindert Fehlermeldung)
      if (delta <= 0) {
        e.preventDefault();
        return;
      }

      // Quantity im Form + überall setzen
      if (!form.querySelector('input[name="quantity"]')) {
        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "quantity";
        form.appendChild(hidden);
      }
      form.querySelector('input[name="quantity"]').value = String(delta);
      setQtyEverywhere(delta);
    },
    true
  );

  // Nach jedem Add-to-Cart Cart Map aktualisieren, damit delta immer stimmt
  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    const res = await _fetch.apply(this, arguments);
    try {
      const url = typeof input === "string" ? input : input?.url;
      if (url && (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))) {
        // kurz nachziehen
        setTimeout(refreshCartMap, 300);
      }
    } catch (e) {}
    return res;
  };

  function init(box) {
    const base = parseFloat(box.dataset.price || "");
    const cur = box.querySelector("[data-bq-cur]");
    const save = box.querySelector("[data-bq-save]");
    const bar = box.querySelector("[data-bq-bar]");
    const btns = [...box.querySelectorAll(".bq_o")];

    function apply(btn) {
      const p = parseInt(btn.dataset.p, 10);
      const d = parseFloat(btn.dataset.d || "0");
      const code = btn.dataset.c || "";

      window.__BUNDLE_QTY__ = p;

      btns.forEach((b) => b.classList.remove("is"));
      btn.classList.add("is");

      if (cur) cur.textContent = String(p);
      if (bar) bar.style.width = prog(p) + "%";

      // Ersparnis Anzeige wieder korrekt
      if (save && !Number.isNaN(base)) {
        const saving = base * d; // 13.99*0.1=1.399->1.40 | 13.99*0.2=2.798->2.80
        save.textContent = d > 0 ? "Du sparst " + money(saving) : "";
      }

      // Optional: Rabattcode speichern
      try {
        if (code) localStorage.setItem("bundle_discount_code", code);
        else localStorage.removeItem("bundle_discount_code");
      } catch (e) {}
    }

    btns.forEach((b) => b.addEventListener("click", () => apply(b)));
    if (btns[0]) apply(btns[0]);
  }

  function boot() {
    document.querySelectorAll("[data-bq]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
